import { APP_PERMISSIONS } from '@exam-center/permission';
import { useHasPermission } from '@shared/permissions';

import { BlockedUserFormProvider, useBlockedUserDetails } from '../../providers';
import { BlockedUserFormLogic } from '../blocked-user-form-logic';
import { BlockedUserReadonlySection } from '../blocked-user-readonly-section';

export default function BlockedUserDetails() {
  const { blockedUserDetails } = useBlockedUserDetails();

  const hasUpdatePermission = useHasPermission(
    APP_PERMISSIONS.ADMIN_BLOCKLIST_MANAGEMENT.BLOCKED_USER.UPDATE,
  );

  if (hasUpdatePermission) {
    return (
      <BlockedUserFormProvider
        initialValues={{
          phoneNumber: blockedUserDetails.phoneNumber ?? undefined,
        }}
      >
        <BlockedUserFormLogic />
      </BlockedUserFormProvider>
    );
  }

  return <BlockedUserReadonlySection />;
}
